import { Api } from "./api"

export class SubscriptionApi extends Api {
  constructor() {
    super('subscriptions', ['planId', 'stripeToken', 'stripeEmail', 'subscriptionCustomerId'])
  }
}
